import React from 'react';
import CardMedia from '@mui/material/CardMedia';
import { Box, Grid } from '@mui/material';

import { Typography, Link, ImageIcon, Card, CardContent } from '@occc-app/design-system';
import { MarketingContentFragment } from '@occc/graphql';

type MarketingContentPreviewProps = {
  marketingContent: Pick<
    MarketingContentFragment,
    | 'imageUrl'
    | 'title'
    | 'shortDescription'
    | 'longDescription'
    | 'terms'
    | 'termsUrl'
    | 'disclaimer'
    | 'disclaimerUrl'
    | 'externalUrl'
    | 'surgeonGeneralsWarning'
  >;
};

export const MarketingContentPreview = ({ marketingContent }: MarketingContentPreviewProps) => {
  const {
    imageUrl,
    title,
    shortDescription,
    longDescription,
    terms,
    termsUrl,
    disclaimer,
    disclaimerUrl,
    externalUrl,
    surgeonGeneralsWarning,
  } = marketingContent;

  return (
    <Card sx={{ mb: 0 }}>
      <CardMedia
        sx={({ palette }) => ({
          minHeight: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: palette.grey[300],

          '& > svg': {
            fontSize: '5rem',
            color: palette.grey[400],
          },
        })}
        image={imageUrl ?? undefined}
      >
        {!imageUrl && <ImageIcon />}
      </CardMedia>
      <CardContent>
        <Typography variant='subtitle1' component='h4' gutterBottom>
          {title || 'Title'}
        </Typography>

        <Typography gutterBottom>
          {shortDescription || 'This is where short description will live'}
        </Typography>

        {longDescription && <Typography variant='body2'>{longDescription}</Typography>}

        <Grid container spacing={2}>
          <Grid item sm={6}>
            <Box display='flex' flexDirection='column'>
              {terms && (
                <Typography gutterBottom sx={{ overflowWrap: 'break-word' }}>
                  {terms}
                </Typography>
              )}
              {termsUrl && (
                <Typography href={termsUrl} target='_blank' component={Link} gutterBottom>
                  Terms and Conditions
                </Typography>
              )}
            </Box>
          </Grid>

          <Grid item sm={6}>
            <Box display='flex' flexDirection='column'>
              {disclaimer && (
                <Typography gutterBottom sx={{ overflowWrap: 'break-word' }}>
                  {disclaimer}
                </Typography>
              )}
              {disclaimerUrl && (
                <Typography href={disclaimerUrl} target='_blank' component={Link}>
                  Disclaimer
                </Typography>
              )}
            </Box>
          </Grid>

          {externalUrl && (
            <Grid item sm={6}>
              <Typography href={externalUrl} target='_blank' component={Link}>
                External URL
              </Typography>
            </Grid>
          )}
        </Grid>

        {surgeonGeneralsWarning && (
          <Typography variant='body2'>{surgeonGeneralsWarning}</Typography>
        )}
      </CardContent>
    </Card>
  );
};
